function modalReview() {
    const modalReview = document.getElementById('review');
    if(!modalReview) return;
    
    const modalReviewBtn = modalReview.querySelector('.btn_submit');
    if(!modalReviewBtn) return;

    const modalReviewStars = modalReview.querySelectorAll('[type="radio"]');
    const modalReviewText = modalReview.querySelectorAll('[type="text"]');
    const modalReviewHidden = modalReview.querySelector('.bx-element-id');

    const modalReviewBx = modalReview.querySelector('.bx-item-id');
    const modalReviewTextarea = modalReview.querySelector('.form__field-textarea');
    

    modalReviewBtn.classList.add('btn_submit__opacity');
    modalReviewBtn.disabled = true;

    const descriptorProp = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const descriptorAttr = Object.getOwnPropertyDescriptor(Element.prototype, 'setAttribute');

    const isValedInputRadio = () => {
        return Array.from(modalReviewStars).some(item => !!item.checked);
    }

    const isValedInputHidde = () => {
        return !!modalReviewHidden.value;
    }

    const isValedInputBx = () => {
        return !!modalReviewBx.value;
    }

    const isValedInputText = () => {
        return Array.from(modalReviewText).every(item => !!item.value);
    }

    const isValedInputArea = () =>  {
        return !!modalReviewTextarea.value;
    }

    const isValed = () => {
        const isVAL = isValedInputRadio() && isValedInputText() && isValedInputBx() && isValedInputHidde() && isValedInputArea()
        modalReviewBtn.disabled = !isVAL;
        
        isVAL ? modalReviewBtn.classList.remove('btn_submit__opacity') :
            modalReviewBtn.classList.add('btn_submit__opacity');
    }

    const asyncIsValid = () => {
        setTimeout(() => {isValed()}, 100 )
    }
    
    Object.defineProperties(modalReviewBx, {
        value: {
          get: descriptorProp.get,
          set(value) {
            asyncIsValid();
            descriptorProp.set.call(this, value);
          },
        },
        setAttribute: {
          value(attr, value) {
            if (attr === 'value') asyncIsValid();

            descriptorAttr.value.call(this, attr, value);
          },
        }
      });

    const EventInputText = () => {
        Array.from(modalReviewText).forEach(item => {
            item.addEventListener('input', isValed);
            item.addEventListener('change', isValed);
            item.addEventListener('paste', isValed);
        });
    }

    const EventInputBx = () => {
        modalReviewBx.addEventListener('input', (ev) => {
            const val = ev.target.value;
            if (!val)  modalReviewHidden.value = '';
            asyncIsValid();
        });
        modalReviewBx.addEventListener('change', isValed);
        modalReviewBx.addEventListener('paste', isValed);
        };

    const EventInputHidden = () => {
        modalReviewHidden.addEventListener('input', asyncIsValid());
        modalReviewHidden.addEventListener('change', asyncIsValid());
        modalReviewHidden.addEventListener('paste', isValed);
    }

    const EventInputRadio = () => {
        Array.from(modalReviewStars).forEach(item => item.addEventListener('input', isValed));
    }

    const EventInputArea = () => {
        modalReviewTextarea.addEventListener('input', isValed);
    }

    EventInputText();
    EventInputHidden();
    EventInputArea(); 
    EventInputRadio();
    EventInputBx();
            
}
modalReview();